import { combineLatestWith, Observable, startWith } from 'rxjs'
import { map } from 'rxjs/operators'
import { Pipe, PipeTransform } from '@angular/core'

import { LocalizationService } from '@app-domains/localization/service/localization.service'
import { PositionedPageEnum } from '@app-graphql/schema'
import { Localization } from '@aa-app-localization'
import { PageService, PositionedPageSlugsTable } from '@app-services'

@Pipe({
    name: 'positionedPageLink',
    standalone: false,
})
export class PositionedPageLinkPipe implements PipeTransform {
    constructor(
        private localization: LocalizationService,
        private positionedPageService: PageService,
    ) {
    }

    transform(identifier: PositionedPageEnum, rangeValue?: string): Observable<string | null> {
        return this.positionedPageService.slugsTable$.pipe(
            combineLatestWith(this.localization.currentLocale$),
            startWith<[PositionedPageSlugsTable, Localization.Locale]>([
                this.positionedPageService.slugsTable!,
                this.localization.getCurrentLocale(),
            ]),
            map(([table, locale]) => this.createUrl(identifier, table, locale, rangeValue)),
        )
    }

    private createUrl(
        identifier: PositionedPageEnum,
        table: PositionedPageSlugsTable,
        locale: Localization.Locale,
        rangeValue?: string,
    ): string | null {
        if (! table) {
            return null
        }

        const entries = table[identifier]
        if (! entries || entries.length === 0) {
            return null

        }
        const selectedEntry = rangeValue
            ? entries.find(entry => entry[locale]?.slug === rangeValue)
            : entries[0]

        if (! selectedEntry) {
            return null
        }

        const slug = selectedEntry[locale]?.slug

        return slug
            ? `/${locale}/p/${slug}`
            : null
    }
}
